import * as React from 'react';

const CreditCardBackRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={36} height={32} viewBox="0 0 192 128" fill="none" {...props}>
        <g
            clipPath="url(#credit-card-back-rebranding_svg__clip0_101_987)"
            fill="#000"
        >
            <path d="M144 91H80v8h64v-8zM152 91h16v8h-16v-8z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 81a4 4 0 014-4h19a4 4 0 014 4v14a4 4 0 01-4 4H27a4 4 0 01-4-4V81zm5-1a2 2 0 100 4h5a2 2 0 100-4h-5zm0 6a2 2 0 100 4h5a2 2 0 100-4h-5zm-2 8a2 2 0 012-2h5a2 2 0 110 4h-5a2 2 0 01-2-2zm14-14a2 2 0 100 4h5a2 2 0 100-4h-5zm-2 8a2 2 0 012-2h5a2 2 0 110 4h-5a2 2 0 01-2-2zm2 4a2 2 0 100 4h5a2 2 0 100-4h-5z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16zm160 8H16a8 8 0 00-8 8v8h176v-8a8 8 0 00-8-8zM8 112V44h176v68a8 8 0 01-8 8H16a8 8 0 01-8-8z"
            />
        </g>
        <defs>
            <clipPath id="credit-card-back-rebranding_svg__clip0_101_987">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

CreditCardBackRebrandingSvg.displayName = 'CreditCardBackRebrandingSvg';
export default CreditCardBackRebrandingSvg;
